import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import SimpleButton from "../../Buttons/SimpleButton.js";

import { ReactComponent as PuzzleIcon } from "./../../Global/icons/puzzle.svg";
import { ReactComponent as CheckIcon } from "./../../Global/icons/checkCircle.svg";

const StyledForCompanies = styled(NanoFlex)`
  border-radius: 10px;
  overflow: hidden;
  height: auto;

  .yellowBlock {
    padding: 120px 100px;
    background: ${(props) => props.theme.color.primaryColors.lighterYellow};
    gap: 96px;
    border-radius: 10px;

    .leftContent {
      gap: 40px;

      h3 {
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
        font-weight: 500;
      }
    }

    .rightContent {
      gap: 52px;
      padding: 0 0 0 96px;

      .textBlock {
        height: auto;
        gap: 16px;

        h5 {
          text-transform: none;

          color: ${(props) => props.theme.color.primaryColors.darkPurple};
        }

        .blockSubTitle {
          gap: 20px;

          h5 {
            font-weight: 500;
          }

          svg {
            height: 29px;
            width: auto;
          }
        }

        .blockArticle {
          height: auto;
          padding-left: 50px;
        }
      }
    }
  }

  /* SMALL DESKTOPS */
  @media only screen and (max-width: 1450px) {
    .yellowBlock {
      padding: 74px 50px;
    }
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    .yellowBlock {
      padding: 32px 30px;
      gap: 32px;

      .leftContent {
        gap: 24px;
      }

      .rightContent {
        padding: 0px;
        gap: 24px;

        .textBlock {
          gap: 8px;
        }
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    border-radius: 5px;

    .yellowBlock {
      padding: 32px 20px;
      border-radius: 5px;

      .textBlock {
        .rightContent {
          .blockSubTitle {
            gap: 28px;
            svg {
              height: 21px;
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 650px) {
    .yellowBlock {
      flex-direction: column;

      .leftContent {
        gap: 16px;

        h3 {
          font-weight: 600;
        }
      }

      .rightContent {
        gap: 24px;
        svg {
          display: none;
        }
        .textBlock {
          .blockSubTitle {
            h5 {
              font-weight: 600;
            }
          }

          .blockArticle {
            padding-left: 0;

            h5 {
              font-size: 12px;
              line-height: 15px;
            }
          }
        }
      }

      .button {
        width: 100%;
        button {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
    .yellowBlock {
      padding: 24px 16px;
    }
  }
`;

export default class ForCompanies extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }
  render() {
    return (
      <StyledForCompanies flexDirection="column" className="forCompaniesBlock">
        <NanoFlex className="yellowBlock">
          <NanoFlex className="leftContent" flexDirection="column" alignItems="flex-start">
            <Type.h3>{this.translation.homepage.forCompanies.blockTitle}</Type.h3>
            <Link to="/assessment">
              <SimpleButton darkPurple label={this.translation.homepage.forCompanies.knowMore}></SimpleButton>
            </Link>
          </NanoFlex>
          <NanoFlex className="rightContent" flexDirection="column" alignItems="flex-start">
            <NanoFlex className="textBlock" justifyContent="flex-start" flexDirection="column">
              <NanoFlex className="blockSubTitle" justifyContent="flex-start">
                <PuzzleIcon />
                <Type.h5>{this.translation.homepage.forCompanies.consciousChoices}</Type.h5>
              </NanoFlex>

              <NanoFlex className="blockArticle" justifyContent="flex-start">
                <Type.h5>{this.translation.homepage.forCompanies.consciousChoicesText}</Type.h5>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="textBlock" justifyContent="flex-start" flexDirection="column">
              <NanoFlex className="blockSubTitle" justifyContent="flex-start">
                <CheckIcon />
                <Type.h5>{this.translation.homepage.forCompanies.findPerson}</Type.h5>
              </NanoFlex>
              <NanoFlex className="blockArticle" justifyContent="flex-start">
                <Type.h5>{this.translation.homepage.forCompanies.findPersonText}</Type.h5>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledForCompanies>
    );
  }
}
